<style lang="scss">
  .homeCats {
    margin: -120px 0 0 0;
    padding: 300px 0 100px 0;
    background-color: #fafafa;
    position: relative;
    .container {
      > ul {
        > li {
          position: relative;
          .btnPrev,
          .btnNext {
            position: absolute;
            top: 170px;
            width: 60px;
            height: 60px;
            background-color: #B9DD64;
            border-radius: 30px;
            z-index: 10;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 48px 24px;
          }
          .btnPrev {
            left: -30px;
            background-image: url('/static/images/icons/slider-left.svg');
          }
          .btnNext {
            right: -30px;
            background-image: url('/static/images/icons/slider-right.svg');
          }
        }
      }
    }
    .books {
      position: relative;
      z-index: 1;
    }
    .mobileBooks {
      position: relative;
      z-index: 2;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 30px;
    }
    @media (min-width: 992px) {
      .mbWr {
        display: none;
      }
    }
  }
</style>
<template>
  <div class="homeCats">
    <div class="container">
      <ul>
        <li
          v-if="catItem.books.length > 0"
          v-for="(catItem, index) in catList"
          :key="index">
          <FrontendBooklistHeader
            :title="catItem.name"
            :url="catItem.url"
            :order="false"
            :cats="[]"
          ></FrontendBooklistHeader>
          <swiper :options="swiperOption" class="books d-none d-lg-block">
            <swiper-slide v-for="book in catItem.books" :key="'book-'+book.id">
              <FrontendBooklink
                :button="false"
                :book="book"
              ></FrontendBooklink>
            </swiper-slide>
          </swiper>
          <div v-if="catItem.books.length > 5" class="btn btnPrev d-none d-lg-block"></div>
          <div v-if="catItem.books.length > 5" class="btn btnNext d-none d-lg-block"></div>
          <div class="mbWr">
          <div class="mobileBooks">
            <FrontendBooklink
              v-for="book in catItem.books.slice(0, 2)"
              :key="'book-'+book.id"
              :button="false"
              :book="book"
            ></FrontendBooklink>
          </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FrontendBooklistHeader from '../partials/booklistheader'
import FrontendBooklink from '../partials/booklink'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'FrontendHomeCategories',
  components: {
    FrontendBooklink,
    FrontendBooklistHeader,
    swiper,
    swiperSlide
  },
  props: {
    catList: { type: Object }
  },
  data: function () {
    return {
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 40,
        navigation: {
          nextEl: '.btnNext',
          prevEl: '.btnPrev'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/home/categories.vue